import React from 'react';
import { hex } from 'color-convert';
import { MdPlayArrow } from 'react-icons/md';
import styled, { css } from 'styled-components/macro';

//utils
import { onInteractiveCTAClick } from 'utils/helpers';
import { InteractiveCTAOption } from 'types';

type OnScreenPlayButtonWithCtaProps = {
  r: number;
  g: number;
  b: number;
};

const OnScreenPlayButtonWithCtaWrapper = styled.div<OnScreenPlayButtonWithCtaProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  background: rgba(
    ${props => props.r},
    ${props => props.g},
    ${props => props.b},
    0.5
  );
  cursor: pointer;
  position: absolute;
  padding: 24px;
  border-radius: 12px;
  z-index: 0;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

type OnScreenPlayButtonProps = {
  r: number;
  g: number;
  b: number;
  playButtonPosition?: string;
  isVideoPaused?: boolean;
  small?: boolean;
};

const OnScreenPlayButtonWrapper = styled.div<OnScreenPlayButtonProps>`
  display: ${props => (props.isVideoPaused ? 'flex' : 'none')};
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  align-items: stretch;
  background: rgba(
    ${props => props.r},
    ${props => props.g},
    ${props => props.b},
    0.5
  );
  font-size: ${props => (props.small ? '10px' : '40px')};
  cursor: pointer;
  width: ${props =>
    `${
      props.small ? '54px' : '208px'
    }`}; /*TODO: Check with Andrija, it's 120px on one screen and 100px on another*/
  height: ${props =>
    `${
      props.small ? '54px' : '208px'
    }`}; /*TODO: Check with Andrija, it's 120px on one screen and 100px on another*/
  position: absolute;
  z-index: 0;

  ${props =>
    props.playButtonPosition === 'center' &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}

  ${props =>
    props.playButtonPosition === 'top-left' &&
    css`
      top: 5%;
      left: 5%;
    `}

  ${props =>
    props.playButtonPosition === 'top-right' &&
    css`
      top: 5%;
      right: 5%;
    `}

  ${props =>
    props.playButtonPosition === 'bottom-left' &&
    css`
      bottom: 23%;
      left: 5%;
    `}

  ${props =>
    props.playButtonPosition === 'bottom-right' &&
    css`
      bottom: 23%;
      right: 5%;
    `}

  ${props =>
    props.playButtonPosition === 'none' &&
    css`
      display: none;
    `}

    @media screen and (max-width: 520px) {
    display: none;
  }
`;

const CTAButton = styled.a`
  color: ${props => props.theme.colors.secondary[100]};
  background: ${props => props.theme.colors.white[100]};
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  opacity: 1 !important;
  min-width: 160px;
  height: 40px;
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  box-sizing: border-box;
  border-radius: 5px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px 8px 8px;
  white-space: nowrap;
  text-align: center;
`;

type Props = {
  playerBackgroundColor: string;
  playButtonPosition: string;
  isVideoPaused: boolean;
  togglePlay: () => void;
  isVideoFinished: boolean;
  playerIconsColor: string;
  interactiveCTAs?: InteractiveCTAOption[];
  showContactInfoModal?: boolean;
  isVideoPlayed?: boolean;
  setShowCtaVideoModal: Function;
};

export const OnScreenPlayButton = (props: Props) => {
  const {
    playerBackgroundColor,
    playButtonPosition,
    isVideoPaused,
    isVideoPlayed,
    togglePlay,
    isVideoFinished,
    playerIconsColor,
    interactiveCTAs,
    setShowCtaVideoModal,
    showContactInfoModal = false,
  } = props;

  const newColor = hex.rgb(playerBackgroundColor);
  const showPlayButton =
    !showContactInfoModal &&
    (interactiveCTAs?.length === 0 || !isVideoFinished);

  return (
    <>
      {showPlayButton &&
        (playButtonPosition !== 'center' || !isVideoPlayed) && (
          <OnScreenPlayButtonWrapper
            isVideoPaused={isVideoPaused}
            onClick={togglePlay}
            r={newColor[0]}
            g={newColor[1]}
            b={newColor[2]}
            playButtonPosition={playButtonPosition}
            small={true}
          >
            <MdPlayArrow
              style={{ margin: '0 auto' }}
              color={playerIconsColor}
              size={25}
            />
          </OnScreenPlayButtonWrapper>
        )}
      {interactiveCTAs?.length !== 0 &&
        isVideoPlayed &&
        (isVideoFinished || isVideoPaused) && (
          <OnScreenPlayButtonWithCtaWrapper
            r={newColor[0]}
            g={newColor[1]}
            b={newColor[2]}
          >
            {interactiveCTAs?.map((button: InteractiveCTAOption, i: number) => (
              <React.Fragment key={i}>
                <CTAButton
                  onClick={() =>
                    onInteractiveCTAClick(button, setShowCtaVideoModal)
                  }
                  key={i}
                >
                  {button.label || button?.title}
                </CTAButton>
              </React.Fragment>
            ))}
          </OnScreenPlayButtonWithCtaWrapper>
        )}
    </>
  );
};
